
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { DataSyncIndicator } from './DataSyncIndicator';

interface NavBarProps {
  title: string;
  logo?: string;
  showBackButton?: boolean;
  backButtonPath?: string;
  colorScheme?: string;
  renderMenuButton?: () => React.ReactNode;
}

const NavBar: React.FC<NavBarProps> = ({ 
  title, 
  logo, 
  showBackButton = false, 
  backButtonPath = '/',
  colorScheme = 'bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600',
  renderMenuButton
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <header className="sticky top-0 z-50 w-full animate-fade-in">
      <div className={`${colorScheme} text-white shadow-lg`}>
        <div className="container flex h-16 items-center px-4 sm:px-6">
          {renderMenuButton && (
            <div className="mr-2">
              {renderMenuButton()}
            </div>
          )}
          {showBackButton && (
            <div className="flex items-center mr-4 hover:scale-110 transition-transform cursor-pointer" onClick={() => navigate(backButtonPath)}>
              <ArrowLeft className="h-5 w-5" />
              <span className="sr-only">{t('common.back')}</span>
            </div>
          )}
          <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
          <div className="ml-auto flex items-center gap-3">
            <DataSyncIndicator />
            {logo && (
              <img 
                src={logo} 
                alt={`${title} logo`} 
                className="h-10 w-10 object-contain logo-bounce" 
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
